/**
 * Havazon integration seams.
 *
 * Campuzon is a venture inside the Havazon ecosystem, not Havazon itself. Every
 * shared capability is reached through a named boundary so no screen ever talks
 * to a provider directly. In this build the boundaries are declared and stubbed;
 * swapping in live HavaPay / Havazon AI / Havazon Mail services should not
 * require changes above these functions.
 */

export type HavazonService =
  | 'HavaPay'
  | 'Havazon AI'
  | 'Havazon Mail'
  | 'Havazon Cloud'
  | 'Havazon Identity'
  | 'Havazon Notify'

export interface ServiceSeam {
  service: HavazonService
  capability: string
  status: 'connected' | 'planned'
  note: string
}

export const SERVICE_SEAMS: ServiceSeam[] = [
  {
    service: 'Havazon Identity',
    capability: 'Single Campuzon account, MFA, session management',
    status: 'connected',
    note: 'One identity spans every console; roles decide what renders.',
  },
  {
    service: 'HavaPay',
    capability: 'Rent, deposits, booking and ticket payments',
    status: 'planned',
    note: 'Money movement stays with the regulated provider — Campuzon holds records only.',
  },
  {
    service: 'Havazon AI',
    capability: 'Study assistance, housing search, career matching',
    status: 'planned',
    note: 'Answers must come from authorized Campuzon data — never invented records.',
  },
  {
    service: 'Havazon Notify',
    capability: 'Push, email and SMS delivery',
    status: 'connected',
    note: 'Safety alerts bypass quiet hours; everything else respects preferences.',
  },
  {
    service: 'Havazon Cloud',
    capability: 'Document and media storage',
    status: 'connected',
    note: 'Listing media and academic documents.',
  },
  {
    service: 'Havazon Mail',
    capability: 'Institutional and transactional mail',
    status: 'planned',
    note: 'University-branded communication.',
  },
]

export function seamFor(service: HavazonService): ServiceSeam | undefined {
  return SERVICE_SEAMS.find((seam) => seam.service === service)
}
